export default __webpack_public_path__ + "static/Benifit_2-e45f8fac48ecb41af42f49017a4572ea.svg";